export const clearLocalStorageOnce = () => {
  const SESSION_MARKER = "tab_session_marker";
  const LAST_SEEN_KEY = "app_last_seen";
  const TIMEOUT = 10000;

  const now = Date.now();

  // clear only once per tab, but always re-start heartbeat on mount/reload
  const alreadyInitialized = sessionStorage.getItem(SESSION_MARKER);

  if (!alreadyInitialized) {
    sessionStorage.setItem(SESSION_MARKER, "true");

    const lastSeen = Number(localStorage.getItem(LAST_SEEN_KEY) || "0");
    const isNewSession = now - lastSeen > TIMEOUT;

    if (isNewSession) {
      localStorage.clear();
    }
  }

  // heartbeat (while tab is open)
  const interval = setInterval(() => {
    localStorage.setItem(LAST_SEEN_KEY, String(Date.now()));
  }, TIMEOUT);

  localStorage.setItem(LAST_SEEN_KEY, String(now));

  return () => clearInterval(interval);
};
